(() => {
  const SELECTOR = '[data-aurora-header]';

  function initHeader(root) {
    if (!root || root.dataset.auroraReady === 'true') return;

    const openButton = root.querySelector('[data-aurora-menu-open]');
    const drawer = root.querySelector('[data-aurora-drawer]');
    const closeButton = root.querySelector('[data-aurora-menu-close]');
    const panel = drawer?.querySelector('[data-aurora-drawer-panel]');

    if (!openButton || !drawer || !closeButton || !panel) {
      root.dataset.auroraReady = 'true';
      return;
    }

    let lastFocusedElement = null;

    const focusableSelector = [
      'a[href]',
      'button:not([disabled])',
      'input:not([disabled])',
      'select:not([disabled])',
      'textarea:not([disabled])',
      '[tabindex]:not([tabindex="-1"])'
    ].join(',');

    const openDrawer = () => {
      lastFocusedElement = document.activeElement;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      openButton.setAttribute('aria-expanded', 'true');
      document.documentElement.style.overflow = 'hidden';
      window.setTimeout(() => closeButton.focus(), 30);
    };

    const closeDrawer = () => {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      openButton.setAttribute('aria-expanded', 'false');
      document.documentElement.style.overflow = '';
      if (lastFocusedElement instanceof HTMLElement) lastFocusedElement.focus();
    };

    openButton.addEventListener('click', openDrawer);
    closeButton.addEventListener('click', closeDrawer);

    drawer.addEventListener('click', (event) => {
      if (!panel.contains(event.target)) closeDrawer();
    });

    drawer.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeDrawer();
        return;
      }

      if (event.key !== 'Tab') return;
      const focusable = Array.from(panel.querySelectorAll(focusableSelector));
      if (!focusable.length) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    root.dataset.auroraReady = 'true';
  }

  function initAll(scope = document) {
    scope.querySelectorAll(SELECTOR).forEach(initHeader);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
